import { createReducer, on } from '@ngrx/store';
import * as PicklistsActions from '../actions/picklists.actions';

export const picklistsFeatureKey = 'picklists';

export interface State {
  currentPage: number,
  picklists: any,
  picklistsPath: any,
  filterType: string,
  filterID: number
  total: number,
  query: string,
  isLoading: boolean,
  sortType: string,
  direction: string,
  picklist: any,
  selected: any,
  isMasterChecked: boolean,
  templates: '1' | 'all' | null,
  barcodes: any[]

  /**
   * Errors
   */
  duplicateBarcode: boolean
}

export const initialState: State = {
  currentPage: 0,
  picklists: null,
  picklistsPath: null,
  picklist: null,
  filterType: null,
  total: 0,
  filterID: 0,
  query: "",
  isLoading: true,
  sortType: null,
  direction: null,
  selected: [],
  isMasterChecked: false,
  templates: null,
  barcodes: null,
  duplicateBarcode: false
};

export const reducer = createReducer(
  initialState,

  on(PicklistsActions.loadPicklists, (state, action: any) => ({
    ...state,
    templates: action?.templates ?? null
  })),
  on(PicklistsActions.loadPicklistsSuccess, (state, action) => ({
    ...state,
    picklists: [...action.picklists],
    total: action.total,
    isLoading: false
  })),
  on(PicklistsActions.loadPicklistsFailure, (state, action) => state),
  on(PicklistsActions.updatePicklist, state => state),
  on(PicklistsActions.updatePicklistSuccess, (state, { picklist }) => ({
    ...state,
    picklists: state.picklists.map(item => {
      if(picklist!=null && picklist.pickListID!=null && item.pickListID == picklist.pickListID){
        return picklist;
      }else{
        return item
      }
    }),
    picklist: picklist,
    isLoading: false
  })),
  on(PicklistsActions.loadPicklist, state => state),
  on(PicklistsActions.loadPicklistSuccess, (state, action) => ({
    ...state,
    picklist: action.picklist,
    isLoading: false
  })),
  on(PicklistsActions.loadPicklistFailure, (state, action) => state),
  on(PicklistsActions.filterByCategory, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(PicklistsActions.filterByCategorySuccess, (state, action) => ({
    ...state,
    picklists: action.picklists,
    total: action.total,
    isLoading: false
  })),
  on(PicklistsActions.filterByCategoryFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(PicklistsActions.filterByArea, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(PicklistsActions.filterByAreaSuccess, (state, action) => ({
    ...state,
    picklists: action.picklists,
    total: action.total,
    isLoading: false
  })),
  on(PicklistsActions.filterByAreaFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(PicklistsActions.deletePicklist, (state, action) => ({
    ...state,
  })),
  on(PicklistsActions.deletePicklistSuccess, (state, action) => ({
    ...state,
    picklists: state.picklists.filter(picklist => picklist.pickListID != action.pickListID),
  })),
  on(PicklistsActions.deletePicklistsSuccess, (state, action) => ({
    ...state,
    isMasterChecked: false
  })),
  on(PicklistsActions.savePicklist, state => state),
  // Guarded twice: initial state has picklists = null (a save dispatched from
  // the catalog before the picklists page was ever visited would crash the
  // whole store on spread), and a response without a picklist payload must
  // not inject an undefined row into the list.
  on(PicklistsActions.savePicklistSuccess, (state, action) => ({
    ...state,
    picklists: action.picklist ? [action.picklist, ...(state.picklists || [])] : state.picklists,
    total: action.picklist ? state.total + 1 : state.total
  })),
  on(PicklistsActions.savePicklistFailure, (state, action) => state),

  on(PicklistsActions.search, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(PicklistsActions.searchSuccess, (state, action) => ({
    ...state,
    picklists: action.picklists,
    total: action.total,
    isLoading: false
  })),
  on(PicklistsActions.searchFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(PicklistsActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(PicklistsActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(PicklistsActions.resetPage, (state, action) => ({ 
    ...state,
    currentPage: 0
  })),
  on(PicklistsActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(PicklistsActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(PicklistsActions.setFilterType, (state, action) => ({
    ...state,
    filterType: action.filterType,
    filterID: action.filterID
  })),
  on(PicklistsActions.setSelected, (state, action) => ({
    ...state,
    selected: action.selected,
    isMasterChecked: true
  })),
  on(PicklistsActions.setDeselected, (state) => ({
    ...state,
    selected: [],
    isMasterChecked: false
  })),
  on(PicklistsActions.setSort, (state, action) => ({
    ...state,
    sortType: action.sort,
    direction: action.direction
  })),
  on(PicklistsActions.resetPicklist, (state, action) => ({
    ...state,
    picklist: null
  })),
  on(PicklistsActions.resetPicklists, (state, action) => ({
    ...state,
    picklists: [],
    isLoading: true
  })),
  on(PicklistsActions.resetFilter, (state, action) => ({
    ...state,
    filterType: null,
    filterID: null
  })),
  on(PicklistsActions.createBarcode, (state, action) => ({
    ...state,
    barcodes: [...state.barcodes, {
      barcodeData: action.barcodeData
    }],
    duplicateBarcode: false
  })),
  on(PicklistsActions.setBarcodes, (state, action) => ({
    ...state,
    barcodes: action.barcodes
  })),
  on(PicklistsActions.createBarcodeFailure, (state, action) => ({
    ...state,
    duplicateBarcode: true
  })),
  on(PicklistsActions.createBarcodeFailure, (state, action) => ({
    ...state,
    duplicateBarcode: true
  })),
  on(PicklistsActions.setSelectedBarcode, (state, action) => ({
    ...state,
    barcodes: state.barcodes?.map((item, index) => {
      if(index != action.index){
        item.selected = false;
      }else{
        item.selected = true;
      }
      return item;
    })
  })),
  on(PicklistsActions.deleteBarcode, (state, action) => ({
    ...state,
    barcodes: state.barcodes.filter(item => item.barcodeID != action.barcodeID)
  })),
  on(PicklistsActions.setIsLoading, (state, action) => ({
    ...state,
    isLoading: action.isLoading
  })),

);
